import Swiper, { Thumbs, FreeMode, Scrollbar, Mousewheel } from "swiper";
import "swiper/css";
import "swiper/css/thumbs";
import "swiper/css/scrollbar";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

const produktSlider = function() {
    const mainEl = document.querySelector(".main-slider");
    const thumbEl = document.querySelector(".thumbnail-slider");
    if (!mainEl || !thumbEl) return;

    Swiper.use([Thumbs, FreeMode, Scrollbar, Mousewheel]);

   const thumbnailSlider = new Swiper(".thumbnail-slider", {
        direction: "vertical",
        spaceBetween: 5,
        slidesPerView: 4.5,
        freeMode: true,
        mousewheel: {
            forceToAxis: true,
            sensitivity: 0.6
        },
        scrollbar: {
            el: ".thumbnail-slider .swiper-scrollbar",
            draggable: true,
            hide: true
        },
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        autoHeight: false,
        });

    // Main slider
    const mainSlider = new Swiper(".main-slider", {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 5,
        autoHeight: true,
        thumbs: {
            swiper: thumbnailSlider
        },
        navigation: {
            nextEl: '.main-slider .swiper-button-next',
            prevEl: '.main-slider .swiper-button-prev',
        },
        scrollbar: {
            el: ".main-slider .swiper-scrollbar",
            draggable: true,
            hide: false
        },
        watchSlidesProgress: true,
        watchSlidesVisibility: true
    });

    // Thumbnail click -> main slide
    document.querySelectorAll(".thumbnail-slider .swiper-slide").forEach((thumb, index) => {
        thumb.addEventListener("click", function () {
            mainSlider.slideTo(index);
        });
    });

    // Fancybox init (koppla till mainbilder)
    Fancybox.bind("[data-fancybox='gallery']", {
        Toolbar: true,
        smallBtn: true
    });
};

export default produktSlider;